/**
 * Appointments Tour Configuration
 * Introduces users to appointment scheduling features
 */

import { TourDefinition } from './tour.types';

export const appointmentsTour: TourDefinition = {
  id: 'appointments-tour',
  name: 'Appointments Calendar',
  page: '/appointments',
  version: 4, // Improved descriptions for clarity
  nextTourId: 'reminders-tour', // Chain to reminders tour after completion
  steps: [
    {
      id: 'appointments-intro',
      targetSelector: '[data-tour="appointments-header"]',
      title: 'Your Appointments',
      description:
        'Manage all your scheduled appointments here. Track meetings with leads and clients, and sync with your calendar to never miss an important meeting.',
      placement: 'bottom',
    },
    {
      id: 'calendar-toggle',
      targetSelector: '[data-tour="appointments-calendar-btn"]',
      title: 'Calendar View',
      description:
        'Switch to calendar view to see your appointments visually. Choose between day, week, or month formats to plan your schedule effectively.',
      placement: 'bottom',
      onShow: () => {
        // Click the calendar button to switch to calendar view
        setTimeout(() => {
          const btn = document.querySelector('[data-tour="appointments-calendar-btn"]') as HTMLElement;
          if (btn) {
            btn.click();
          }
        }, 100);
      },
    },
    {
      id: 'calendar-view',
      targetSelector: '[data-tour="calendar-view"]',
      title: 'Your Calendar',
      description:
        'This is your appointment calendar. Click on any date to see scheduled meetings or create new ones directly. Appointments are color-coded by status for quick reference.',
      placement: 'left',
    },
    {
      id: 'add-appointment',
      targetSelector: '[data-tour="add-appointment"]',
      title: 'Schedule Appointments',
      description:
        'Click here to schedule a new appointment. Link it to a lead, add notes, and set reminders so you never forget an important meeting.',
      placement: 'left',
    },
  ],
};
